const RECEIPT_TITLE = 'Receipt'

const receiptStyles = `
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; margin: 0; color: #111; }
  .receipt { max-width: 360px; width: 100%; margin: 24px auto; padding: 0 16px 32px; }
  .receipt::after { content: ""; display: block; height: 24mm; }
  .receipt-pad { height: 24mm; border-top: 1px solid #eee; }
  .receipt-pad::after { content: " "; display: block; color: #eee; }
  .header { text-align: center; margin-bottom: 16px; }
  .title { font-size: 18px; font-weight: 700; margin-bottom: 4px; }
  .subtitle { font-size: 12px; color: #555; }
  .section { margin: 16px 0; }
  .row { display: flex; justify-content: space-between; font-size: 12px; margin: 4px 0; gap: 8px; }
  .divider { border-top: 1px solid #ddd; margin: 12px 0; }
  .items { font-size: 12px; }
  .item { margin: 6px 0; }
  .item-name { font-weight: 600; }
  .total { font-weight: 700; font-size: 13px; }
  @media print {
    @page { margin: 6mm; }
    body { margin: 0; }
    .receipt { width: min(72mm, 100%); margin: 0 auto; padding: 0 0 24mm; }
    .receipt::after { height: 24mm; }
    .receipt-pad { height: 24mm; border-top: 1px solid #eee; }
    .receipt-pad::after { content: "\\00a0"; color: #eee; }
    .title { font-size: 16px; }
    .row, .items { font-size: 11px; }
  }
`

export const printHtmlReceipt = (htmlBody: string) => {
  if (typeof window === 'undefined') return
  const html = `
    <html>
      <head>
        <title>${RECEIPT_TITLE}</title>
        <style>${receiptStyles}</style>
      </head>
      <body>
        <div class="receipt">
          ${htmlBody}
          <div class="receipt-pad">&nbsp;</div>
        </div>
      </body>
    </html>
  `

  const iframe = document.createElement('iframe')
  iframe.setAttribute('style', 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;')
  iframe.setAttribute('aria-hidden', 'true')
  document.body.appendChild(iframe)

  const frameWindow = iframe.contentWindow
  if (!frameWindow) {
    iframe.remove()
    throw new Error('Unable to open print frame')
  }

  frameWindow.document.open()
  frameWindow.document.write(html)
  frameWindow.document.close()

  const triggerPrint = () => {
    frameWindow.focus()
    frameWindow.print()
    setTimeout(() => {
      iframe.remove()
    }, 500)
  }

  if (frameWindow.document.readyState === 'complete') {
    setTimeout(triggerPrint, 100)
  } else {
    frameWindow.onload = () => setTimeout(triggerPrint, 100)
  }
}

export const openReceiptPreview = (htmlBody: string) => {
  if (typeof window === 'undefined') return
  const previewWindow = window.open('', '_blank')
  if (!previewWindow) {
    throw new Error('Unable to open print preview')
  }

  const html = `
    <html>
      <head>
        <title>${RECEIPT_TITLE}</title>
        <style>
          ${receiptStyles}
          .preview-toolbar {
            display: flex;
            justify-content: flex-end;
            padding: 12px 16px;
            border-bottom: 1px solid #e5e5e5;
          }
          .preview-btn {
            background: #2563eb;
            color: #fff;
            border: none;
            border-radius: 6px;
            padding: 8px 14px;
            font-size: 14px;
            cursor: pointer;
          }
        </style>
      </head>
      <body>
        <div class="preview-toolbar">
          <button class="preview-btn" onclick="window.print()">Print</button>
        </div>
        <div class="receipt">
          ${htmlBody}
          <div class="receipt-pad"></div>
        </div>
      </body>
    </html>
  `

  previewWindow.document.open()
  previewWindow.document.write(html)
  previewWindow.document.close()
  previewWindow.focus()
}

export const buildTestReceiptHtml = () => {
  return `
    <div class="header">
      <div class="title">Test Receipt</div>
      <div class="subtitle">System Print</div>
    </div>
    <div class="section">
      <div class="row"><span>Item</span><span>Amount</span></div>
      <div class="divider"></div>
      <div class="row"><span>Sample Item</span><span>5 Tokens</span></div>
    </div>
    <div class="divider"></div>
    <div class="section">
      <div class="row total"><span>Total</span><span>5 Tokens</span></div>
    </div>
  `
}

type QrCodePrintData = {
  eventName?: string
  userName?: string
  barcode: string
  qrDataUrl: string
}

export const buildQrCodeReceiptHtml = (data: QrCodePrintData) => {
  return `
    <div class="header">
      <div class="title">${data.eventName || 'EventPay'}</div>
      ${data.userName ? `<div class="subtitle">${data.userName}</div>` : ''}
    </div>
    <div class="section" style="text-align:center;">
      <img src="${data.qrDataUrl}" alt="QR Code" style="width:200px;max-width:70mm;height:auto;margin:0 auto;" />
    </div>
    <div class="section">
      <div class="row"><span>Wallet ID</span><span>${data.barcode}</span></div>
    </div>
  `
}
